import { useForm } from "react-hook-form";
import ErrorLabel from "../error_label";
import $ from "jquery";
import {
  actionSharePolicy,
  resetSharePolicy,
} from "../../routes/app/auth/policies/store";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import toast from "react-hot-toast";

const SharePopup = (props) => {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  const { sharePolicy } = useSelector((state) => ({
    ...state.policyStore,
  }));
  

  useEffect(() => {
    if (sharePolicy) {
      dispatch(resetSharePolicy());
      if (sharePolicy.status) {
        // $("#app-body").removeClass("modal-open");
        // $(".modal-backdrop").remove();
        setValue("email", null);
        props.handleShareClose()
        // window.location.reload()
      }
    }
  }, [sharePolicy]);

  useEffect(() => {
    if (props.isSharePopup) {
      // $('#app-body').addClass('modal-open')
      // $("#app-body").append('<div class="modal-backdrop fade show"></div>');
    }else{
      // $('#app-body').removeClass('modal-open')
      // $('.modal-backdrop').remove()
    }
  }, [props.isSharePopup]);

  const onSubmit = (data) => {
    // $("#app-body").removeClass("modal-open");
    // $('.modal-backdrop').remove();
    setValue("email", null);
    props.handleShareClose();
    toast.success('Email sent successfully');
  };
  

  return (
    <div
      class="modal fade"
      id="share"
      tabindex={-1}
      data-bs-backdrop="static"
      aria-labelledby="share"
      aria-hidden="true"
      style={{ display: props.isSharePopup ? "block" : "none" }}
    >
      <div class="modal-dialog modal-dialog-sm">
        <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="share">
                Share Document
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  props.handleShareClose();
                  // $("#app-body").removeClass("modal-open");
                  // $(".modal-backdrop").remove();
                  setValue("email", null);
                }}
              ></button>
            </div>
            <div class="modal-body">
              <div className="col-12">
                <label>Email Id</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  {...register("email", {
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "invalid email address",
                    },
                    required: "This is required",
                  })}
                />
                {errors.email && <ErrorLabel message={errors?.email.message} />}
              </div>
            </div>
            <div class="modal-footer text-center">
              <button type="submit" class="btn btn-primary ">
                Share
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SharePopup;
